var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProgrammedMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.793,
    height: 20.795,
    viewBox: "0 0 20.793 20.795",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Programmed_Message",
    "data-name": "Programmed Message",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_507",
    "data-name": "Caminho 507",
    d: "M12.318,2A10.318,10.318,0,1,0,22.635,12.318,10.318,10.318,0,0,0,12.318,2Z",
    transform: "translate(-1.951 -2)",
    fill: "#ffb244",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Programmed_Message-2",
    "data-name": "Programmed Message",
    d: "M12.386,2A10.4,10.4,0,1,0,22.793,12.4,10.391,10.391,0,0,0,12.386,2Zm.01,18.714A8.317,8.317,0,1,1,20.714,12.4,8.315,8.315,0,0,1,12.4,20.714ZM12.168,7.2h-.062a.745.745,0,0,0-.749.749v4.907a1.029,1.029,0,0,0,.509.894l4.315,2.589a.744.744,0,1,0,.759-1.279l-4.023-2.391V7.947a.745.745,0,0,0-.749-.749Z",
    transform: "translate(-2 -1.998)",
    fill: "#ffc169",
    opacity: 0.998
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammedMessage);
export default __webpack_public_path__ + "static/media/Programmed Message.4d6d174f.svg";
export { ForwardRef as ReactComponent };